"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./MenuComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var tradeComponentClasses = (0, _cssClassesHelper.getBEMClasses)('trade-component');
var baseClass = 'menu-component';
var MenuComponent = function MenuComponent(props) {
  var dataTest = props.dataTest,
    children = props.children,
    customClass = props.customClass,
    header = props.header;
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)(baseClass, customClass);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(tradeComponentClasses(), " ").concat(bemClasses())
  }, header && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(tradeComponentClasses('header'))
  }, props.header), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "".concat(bemClasses('list')),
    "data-test": dataTest
  }, children));
};
MenuComponent.propTypes = {
  header: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  dataTest: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].element), _propTypes["default"].element])
};
var _default = exports["default"] = MenuComponent;